import React from 'react';
import Player from "./player/HallowAudio";
import { HallowComponent } from "./HallowComponent";
import "./player/style.css";

export const HallowAudio = Player;